import { useMutation } from '@tanstack/react-query';
import { deleteCreatedAudio } from '../../services';

export function useDeleteCreatedAudio() {
  return useMutation(deleteCreatedAudio, { onSuccess: (data) => data });
}
